import React, {Component} from 'react';

class NotFound extends Component {

    render() {
        return (
            <div className="card">
                <h1>Not Found</h1>
                <p>Tracking reference <em>{this.props.tracking_ref}</em> not found.</p>
            </div>
        );
    }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js